import "react";
import { Button, ButtonConfirm, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdDeleteForever, MdEdit } from "react-icons/md";
//#region src/modules/Organizations/shared/Subcription/components/BillingContact.tsx
function BillingContact({ email, name, onDelete, onEdit, phone }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface p-base relative rounded",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "text-color-strong text-lg font-medium tracking-wide",
				children: name
			}),
			/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate",
				children: email
			}),
			/* @__PURE__ */ jsx("div", { children: phone }),
			/* @__PURE__ */ jsx("div", {
				className: "right-xs top-sm bg-surface absolute",
				children: /* @__PURE__ */ jsx(Button, {
					onClick: onEdit,
					subtle: true,
					variant: "main",
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: MdEdit,
						size: "xs"
					})
				})
			}),
			!!onDelete && /* @__PURE__ */ jsx("div", {
				className: "bottom-xs right-xs bg-surface absolute",
				children: /* @__PURE__ */ jsx(ButtonConfirm, {
					confirmationMessage: /* @__PURE__ */ jsxs("div", {
						className: "flex items-center",
						children: [/* @__PURE__ */ jsx("span", {
							className: "text-sm",
							children: "Confirm Deletion"
						}), /* @__PURE__ */ jsx(Icon, {
							Icon: MdDeleteForever,
							size: "sm"
						})]
					}),
					onClick: onDelete,
					subtle: true,
					size: "sm",
					variant: "critical",
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: MdDeleteForever,
						size: "sm"
					})
				})
			})
		]
	});
}
//#endregion
export { BillingContact };

//# sourceMappingURL=BillingContact.js.map